import React from 'react'
import Calendar from '../../../assets/images/calendar.png'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import styles from './DateFilter.module.scss'

const normalizeDate = (date: Date | null): Date | null => {
  if (!date || !(date instanceof Date) || isNaN(date?.getTime())) return null

  const year = date?.getFullYear()
  const month = date?.getMonth()
  const day = date?.getDate()

  return new Date(year, month, day)
}

type DateFilterProps = {
  value: string
  onChange: (date: string) => void
  placeholder?: string
  iconSize?: number
  className?: string
}

const DateFilter: React.FC<DateFilterProps> = ({
  value,
  onChange,
  placeholder = 'DD-MM-YYYY',
  iconSize = 16,
  className = '',
}: DateFilterProps) => {
  const selectedDate = value ? normalizeDate(new Date(value)) : null

  const handleChange = (date: Date | null) => {
    const normalizedDate = normalizeDate(date)
    if (!normalizedDate) return

    const year = normalizedDate?.getFullYear()
    const month = String(normalizedDate?.getMonth() + 1)?.padStart(2, '0')
    const day = String(normalizedDate?.getDate())?.padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`

    onChange(formattedDate)
  }

  return (
    <div
      className={`${styles.dateFilterRoot} ${className}`}
      data-testid='datefilter-root'
    >
      <img
        alt='Calendar'
        src={Calendar}
        className={`${styles.dateFilterIcon} ${styles[`iconSize${iconSize}`]}`}
      />
      <DatePicker
        className={styles.datePickerUI}
        placeholderText={placeholder}
        selected={selectedDate}
        onChange={handleChange}
        dateFormat='dd-MM-yyyy'
        showMonthDropdown
        showYearDropdown
        dropdownMode='select'
        popperPlacement='bottom'
      />
    </div>
  )
}

export default DateFilter
